const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';
const ALPHABET_SIZE = ALPHABET.length;
/** Байты >= этого значения отбрасываем, иначе `byte % ALPHABET_SIZE` даёт смещение (256 не кратно 36). */
const BYTE_REJECT_CUTOFF = Math.floor(256 / ALPHABET_SIZE) * ALPHABET_SIZE;

export const generateCryptoRandomId = (length = 16): string => {
  const webCrypto = typeof window !== 'undefined' ? window.crypto : undefined;
  if (webCrypto?.getRandomValues === undefined) {
    throw new Error('Web Crypto API is not available in this environment');
  }

  const scratch = new Uint8Array(Math.max(length * 2, 32));
  let result = '';

  while (result.length < length) {
    webCrypto.getRandomValues(scratch);
    for (let i = 0; i < scratch.length && result.length < length; i++) {
      const b = scratch[i];
      if (b < BYTE_REJECT_CUTOFF) {
        result += ALPHABET.charAt(b % ALPHABET_SIZE);
      }
    }
  }

  return result;
};

export const generateTimestampedCryptoRandomId = (length = 16): string => {
  return `${Date.now()}_${generateCryptoRandomId(length)}`;
};
